const hexToHSL = hex => {
  hex = hex.replace(/^#/, '')
  let r = parseInt(hex.substring(0, 2), 16) / 255
  let g = parseInt(hex.substring(2, 4), 16) / 255
  let b = parseInt(hex.substring(4, 6), 16) / 255

  let max = Math.max(r, g, b),
    min = Math.min(r, g, b)
  let h,
    s,
    l = (max + min) / 2

  if (max === min) {
    h = s = 0
  } else {
    let d = max - min
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0)
        break
      case g:
        h = (b - r) / d + 2
        break
      case b:
        h = (r - g) / d + 4
        break
    }
    h /= 6
  }

  return { h: h * 360, s: s * 100, l: l * 100 }
}

export const lightenColor = (color, percent) => {
  let hslColor = hexToHSL(color)
  hslColor.l = Math.min(100, hslColor.l + hslColor.l * (percent / 100))
  return hslColor
}

const isDarkColor = hexColor => {
  hexColor = hexColor.replace(/^#/, '')
  let r = parseInt(hexColor.substring(0, 2), 16)
  let g = parseInt(hexColor.substring(2, 4), 16)
  let b = parseInt(hexColor.substring(4, 6), 16)

  let brightness = r * 0.299 + g * 0.587 + b * 0.114
  return brightness < 128
}

export const getDisabledColor = hexColor => {
  if (!hexColor) return '#ddd'
  let hsl = hexToHSL(hexColor)
  if (isDarkColor(hexColor)) {
    hsl.s = hsl.s * 0.5
    hsl.l = Math.min(100, hsl.l + 20)
  } else {
    hsl.l = Math.max(0, hsl.l - 20)
    hsl.s = hsl.s * 0.3
  }
  return `hsl(${hsl.h.toFixed(0)}, ${hsl.s.toFixed(0)}%, ${hsl.l.toFixed(0)}%)`
}

export const getErrorColor = backgroundColor => {
  const baseErrorColor = '#b00020'
  const lightErrorColor = '#FF867C'
  return isDarkColor(backgroundColor) ? lightErrorColor : baseErrorColor
}
